module.exports = __webpack_public_path__ + "img/delayKey.5a5bf541.png";